'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgArrowRight = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { d: "M14.626 4.045c-.206.109-.48.388-.588.599a.795.795 0 0 0 .001.719c.063.124.903.993 2.814 2.907L19.579 11h-8.383c-9.007 0-8.582-.01-8.874.199-.222.158-.302.369-.302.801 0 .331.013.403.1.558.11.197.294.34.515.401.095.027 3.041.041 8.544.041h8.4l-2.726 2.73c-1.911 1.914-2.751 2.783-2.814 2.907-.176.353-.087.717.26 1.064.346.347.711.436 1.064.26.252-.127 7.471-7.337 7.597-7.589a.891.891 0 0 0 .089-.372.891.891 0 0 0-.089-.372c-.122-.244-7.344-7.462-7.588-7.584a.884.884 0 0 0-.746.001", fillRule: "evenodd", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgArrowRight);

exports["default"] = ForwardRef;
//# sourceMappingURL=ArrowRight.js.map
